<template>
  <button
    href="#"
    class="mdn-Menu-top-event"
    title="Conheça as iniciativas de Acessibilidade da Claro"
    @click.prevent="openAcessibility()"
  >
    <span class="mdn-Icon-pcd mdn-Icon--sm" aria-hidden="true"></span>
  </button>
</template>
<script lang="ts">
import Vue from "vue";

import { Component } from "vue-property-decorator";

@Component({
  name: "AccessibilityButton",
})
export default class AccessibilityButton extends Vue {
  openAcessibility(): void {
    const win = window as any;
    win
      .open(
        "https://www.claro.com.br/institucional/regulatorio/acessibilidade",
        "_blank"
      )
      .focus();
  }
}
</script>

<style lang="scss" scoped></style>
